<pk-public-page-wrapper [info]="info"></pk-public-page-wrapper>
